import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ServiceCategories from "./sections/ServiceCategories";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <ServiceCategories />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}